const stylesheet = new CSSStyleSheet();

export function injectRootTheme(
    // eslint-disable-next-line @typescript-eslint/consistent-type-imports
    theme: (typeof import('@dcentralexpedientedigital/config'))['default']['themes']['light'],
) {
    const colors = theme.colors;

    const variables = Object.keys(colors)
        .map((color) => {
            return `--${color}: ${colors[color as keyof typeof colors]};`;
        })
        .join('\n');

    document.adoptedStyleSheets = [...document.adoptedStyleSheets, stylesheet];

    return stylesheet.replace(`
        :root {
            ${variables}
        }
    `);
}
